import React, {Component} from 'react';
import SignaturePad from 'signature_pad/dist/signature_pad.js';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required } from '../Validation/Rules';
import Styles from "../../styles/Styles";


const errorMessageSignaturePad = "Vous devez signer le formulaire."

export default class Signature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validationErrors: {},
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    let canvas = document.getElementById("signaturePad");

    // When zoomed out to less than 100%, for some very strange reason,
    // some browsers report devicePixelRatio as less than 1
    // and only part of the canvas is cleared then.
    let ratio =  Math.max(window.devicePixelRatio || 1, 1);

    // This part causes the canvas to be cleared
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);

    this.signaturePad = new SignaturePad(canvas);
  }

  componentWillUnmount() {}


  handleChange(event) {
    const name = event.target.name;

    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }
  
    // Update the businessHour object
    //responsibles[index][key] = value;
    this.setState({
      [name]: value
    });
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm() {
    let errors = [];
    let checkSignaturePad = this.checkSignaturePad();
    if (checkSignaturePad !== null) {
      errors["signaturePad"] = checkSignaturePad;
    }

    this.setState({
      validationErrors: errors
    });

    return Object.keys(errors).length === 0;
  }

  getObject() {
    return this.signaturePad.toDataURL();
  }

  /**
   * @return String Return the error message if the signature pad is empty ohterwise null
   */
  checkSignaturePad() {
    return this.signaturePad.isEmpty() ? errorMessageSignaturePad : null;
  }

  resetSignaturePad(evt){
    evt.preventDefault();
    evt.stopPropagation();
    this.signaturePad.clear();
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  render() {
    return (
        <fieldset className="form-fieldset">
          <legend className="form-fieldset-legend">Signature</legend>
          <div className="">
            <div className="signature-pad-body">
              <canvas id="signaturePad"></canvas>

            </div>
            <div>
              <span className="form-error">{this.errorFor("signaturePad")}</span>
            </div>
            <button style={Styles.Style.bgColorSecondary}
                    className="margin-top-m btn btn-lg btn-primary-primary"
                    onClick={(evt) => { this.resetSignaturePad(evt); }} >
              Effacer la signature
            </button>
          </div>
        </fieldset>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Forms/Signature.js